import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// import { getToken,removeToken } from '@/utils/auth'
import { getToken,removeToken } from '@/utils/auth-session'

// create an axios instance

console.log('域名：',window.location.host)
console.log(process.env.VUE_APP_BASE_API)
const path_two = window.location.host=='cxcorder.unipock.net'?'/api':'/apitest'
console.log('域名2: ', path_two);
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API+path_two, // api的base_url url = base url + request url
  // withCredentials:true，//跨域请求时发送cookies
  timeout: 50000, // 请求超时时间
  // headers:{
  //   "Content-Type":"application/x-www-form-urlencoded;charset-utf-8"
  // }
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
    }
    // 生產環境判斷為 /dev-api/api/login_user  開發環境判斷為/api/login_user
    // if(!localStorage.getItem('code') && config.url != '/dev-api/api/login_user'){
    //   console.log('進入請求壞賬')
    //   let timeMsg;
    //   if(localStorage.getItem('locale') === 'zh_tw'){
    //     timeMsg = '閒置時間過長，請重新登入';
    //   }else{
    //     timeMsg = 'Idle for too long, please re-login';
    //   }
    //   Message({ message: timeMsg, duration: 2 * 1000 });
    //   setTimeout(function(){
    //     removeToken()
    //     localStorage.clear();
    //     location.reload();   //js刷新页面方法
    //   }, 3000);
    // }

    // console.log('config: ', config);
    return config

  },
  error => {

    // do something with request error
    console.log(error,'错误的請求') // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * 如果您想获取http信息，如头或状态
   * 请返回response=>response
  */

  /**
   * 通过自定义代码确定请求状态
   * 这里只是一个例子
   * 您还可以通过HTTP状态代码来判断状态
   */
  response => {

    // if(!localStorage.getItem('code') && response.config.url != '/dev-api/api/login_user'){
    //   console.log('進入響應壞賬')
    //   let timeMsg;
    //   if(localStorage.getItem('locale') === 'zh_tw'){
    //     timeMsg = '閒置時間過長，請重新登入';
    //   }else{

    //     timeMsg = 'Idle for too long, please re-login';
    //   }
    //   Message({ message: timeMsg, duration: 2 * 1000 });
    //   setTimeout(function(){
    //     removeToken()
    //     localStorage.clear();
    //     location.reload();   //js刷新页面方法
    //   }, 3000);
    //   this.$router.push({ path: '/login'});
    // }
    let timeMsg;

    let res = response.data
    // console.log('響應的參數：',res)
    // console.log('响应的data-response',response)
    // if the custom code is not 20000, it is judged as an error.

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()  // 为了重新实例化vue-router对象 避免bug
      //     })
      //   })
      // }
   if(res.code==2){
      timeMsg = '網絡欠佳，請稍後再試。' || 'Error';
      Message({ message: timeMsg, duration: 3 * 1000 ,type: 'error',});
      return Promise.reject(new Error(res.message || 'Error'))
    }else {
      return res
    }

    // else if(res.code==0){
    //   timeMsg = '賬號或者密碼錯誤！';
    //   Message({ message: timeMsg, duration: 2 * 1000 ,type: 'error',});
    // }
  },
  error => {
    let timeMsg;
    timeMsg = '網絡欠佳，請稍後再試。'
    console.log('err' + error) // for debug
    Message({message:timeMsg ,type: 'error',duration: 5 * 1000})
    return Promise.reject(error)
  }
)

export default service
